import { useState, useContext, useEffect } from 'react';
import ContextStates from '../../context/ContextStates';
import Layout from '../../components/admin/Layout';

import FormPresupuestos from '../../components/admin/formPresupuestos';
import ListadoPresupuestos from '../../components/admin/listadoPresupuestos';

const Presupuestos = () => {
    const [tab, setTab] = useState(0)
    const { setPresupuesto } = useContext(ContextStates)

    useEffect(() => {
        setPresupuesto(true)
    }, [])

    return (
        <Layout
            pagina={"Presupuestos"}
        >
            <div className='w-full min-h-full'>

            <div className='w-10/12 mx-auto mt-2'>
                <div className='flex'>
                    <button
                        type='button'
                        className={`p-2 rounded-lg text-white ${tab === 0 ? 'bg-blue-600':'bg-blue-300'}`}
                        onClick={()=>setTab(0)}
                    >
                        Nuevo Presupuesto
                    </button>
                    <button
                        type='button'
                        className={`p-2 ml-2 rounded-lg text-white ${tab === 1 ? 'bg-blue-600':'bg-blue-300'}`}
                        onClick={()=>setTab(1)}
                    >
                        Listar Presupuestos
                    </button>
                </div>
            </div>
            { tab === 0 ? (
                <div className='w-full'>
                    <h1 className="mt-1 mb-1 text-gray-600 text-3xl text-center">Presupuestos</h1>
                    <FormPresupuestos />

                </div>
            ):(
                <ListadoPresupuestos />
            )}
            </div>
        </Layout>
    )
}

export default Presupuestos